import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IssueAuditStatus } from '../../../classes';
import { IssueService } from '../../../services/issue.service';

@Component({
  selector: 'app-issue-status-dialog',
  templateUrl: './issue-status-dialog.component.html',
  styleUrls: ['./issue-status-dialog.component.css']
})
export class IssueStatusDialogComponent implements OnInit {

  issueStatus: IssueAuditStatus[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: IssueAuditStatus[],
    private _dialogRef: MatDialogRef<IssueStatusDialogComponent>,
    private _snackBar: MatSnackBar,
    private _issueService: IssueService,
    private _router: Router
  ) {
    this.issueStatus = _data;
  }

  close = () => this._dialogRef.close();

  ngOnInit(): void {
  }

  tryNavigation() {
    let issueId = Array.isArray(this.issueStatus) && this.issueStatus.length > 0 ? this.issueStatus[0].issueid : null;
    if (!issueId) {
      this._snackBar.open('Die Details des Vorgangs können nicht angezeigt werden', 'Ok', {
        duration: 3000
      });
      return;
    }
    this._issueService.getIssueById(issueId, true).subscribe({
      next: () => {
        this._router.navigate(['/issue-details', issueId]);
        this._dialogRef.close();
      },
      error: (error: HttpErrorResponse) => {
        switch (error.status) {
          case 404:
            this._snackBar.open(`Fehler beim Abrufen des Vorgangs: der Vorgang wurde nicht gefunden (${error.status}). Dieser Fehler tritt üblicherweise auf, wenn der Vorgang zwischenzeitlich gelöscht wurde. In diesem Fall existiert kein Datensatz mehr, welcher angezeigt werden kann.`, 'Ok', {
              duration: 5000
            })
            break;
          default:
            this._snackBar.open(`Fehler beim Anzeigen des Vorgangs (${error.status})`);
            break;
        }
      }
    })
  }

}
